var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuotationResourceForm',{attrs:{"form":_vm.readonlyForm.resource,"emissionType":_vm.firstForm.emissionType,"submodalityType":_vm.firstForm.subModality},on:{"submit":_vm.submit,"cancel":_vm.cancelQuotationButton,"return":_vm.previousStep},model:{value:(_vm.formResource),callback:function ($$v) {_vm.formResource=$$v},expression:"formResource"}})
}
var staticRenderFns = []

export { render, staticRenderFns }